// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"16f67cb5","57":"078f02a0","124":"f43ec20a","270":"0a3e75bf","353":"6e35d727","449":"e19bfc11","453":"038c151b","660":"dff304d2","697":"1dec0a87","819":"e854cf30"}[chunkId] + ".chunk.js";
};